module.exports = __webpack_public_path__ + "static/media/img-5.0d30189b.gif";